import { FC } from "react";
import { AppThemeIconProperty } from "../Types";
import IconPropertyCard from "../Cards/IconPropertyCard";
import { Grid } from "@material-ui/core";

type IconPropertiesListProps = {
  propertiesList: AppThemeIconProperty[];
};

const IconPropertiesList: FC<IconPropertiesListProps> = ({ propertiesList }) => {
  const sortedProps = [...propertiesList].sort((a, b) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );

  return (
    <>
      <Grid container spacing={2} sx={{ padding: '1%' }}>
        {sortedProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={4} key={property.themeIconPropertyKey}>
            <IconPropertyCard property={property} key={property.themeIconPropertyKey} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default IconPropertiesList;